/**
 * A2UI basicCatalog 의 `--a2ui-*` CSS 변수를 design-system semantic 토큰(CSS 변수)로 매핑한다.
 * A2uiPanel 래퍼에 인라인으로 얹으면 basicCatalog 하위 컴포넌트가 이 값을 상속한다. 값 자체가
 * `var(--color-*)` 를 참조하므로 런타임 테마(프리셋/다크/accent)와 area 편집이 그대로 반영된다.
 * (basicCatalog 기본 CSS 는 :where() specificity 0 이라 이 인라인 변수가 항상 이긴다.)
 */
export function a2uiThemeVars(): Record<string, string> {
  return {
    // 색
    '--a2ui-color-background': 'var(--color-bg-surface)',
    '--a2ui-color-on-background': 'var(--color-text-primary)',
    '--a2ui-color-surface': 'var(--color-bg-surface-2)',
    '--a2ui-color-on-surface': 'var(--color-text-primary)',
    '--a2ui-color-primary': 'var(--color-accent)',
    '--a2ui-color-primary-hover': 'var(--color-accent-hover)',
    '--a2ui-color-on-primary': 'var(--color-accent-fg)',
    '--a2ui-color-secondary': 'var(--color-bg-surface-2)',
    '--a2ui-color-secondary-hover': 'var(--color-bg-hover)',
    '--a2ui-color-on-secondary': 'var(--color-text-primary)',
    '--a2ui-color-border': 'var(--color-border)',
    '--a2ui-color-input': 'var(--color-bg-muted)',
    '--a2ui-color-on-input': 'var(--color-text-primary)',
    // 모양/테두리
    '--a2ui-border-radius': 'var(--radius-md)',
    '--a2ui-border': '1px solid var(--color-border)',
    // 스케일 — 인라인 스타일 basic 컴포넌트(Row/Column/List/Divider/Video/AudioPlayer/DateTimeInput/
    // Icon)가 참조하는 A2UI 공식 폰트·라인 스케일을 DS 토큰으로 매핑 → 프리셋/다크를 추종한다.
    // NOTE: 스페이싱(--a2ui-spacing-*)은 a2ui.css 베이스 규칙에 둔다 — 인라인이면
    // [data-density='compact'] 스타일시트 오버라이드를 (인라인>스타일시트 우선순위로) 못 이긴다.
    '--a2ui-font-size-xs': 'var(--text-xs)',
    '--a2ui-font-size-s': 'var(--text-sm)',
    '--a2ui-font-size-m': 'var(--text-base)',
    '--a2ui-font-size-l': 'var(--text-lg)',
    '--a2ui-font-size-xl': 'var(--text-xl)',
    '--a2ui-line-height-body': 'var(--leading-normal)',
    '--a2ui-line-height-headings': 'var(--leading-tight)',
    '--a2ui-label-font-weight': 'var(--font-medium)',
    '--a2ui-text-caption-color': 'var(--color-text-muted)',
    // 미디어 radius (roundness 노브 추종)
    '--a2ui-image-border-radius': 'var(--radius-md)',
    '--a2ui-video-border-radius': 'var(--radius-md)',
    '--a2ui-audioplayer-border-radius': 'var(--radius-md)',
    // 카드
    '--a2ui-card-background': 'var(--color-bg-surface)',
    '--a2ui-card-border': '1px solid var(--color-border)',
    '--a2ui-card-border-radius': 'var(--radius-lg)',
    '--a2ui-card-box-shadow': 'var(--shadow-sm)',
    '--a2ui-card-padding': 'var(--space-4)',
    // 타이포
    '--a2ui-font-family-title': 'var(--font-sans)',
    '--a2ui-font-family-monospace': 'var(--font-mono)',
  };
}
